module.exports = __webpack_public_path__ + "static/media/minnie@2x.2167218a.png";